import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getStartAPetitionPageData } from './api';
import type { StartAPetitionPageDataErrorCode } from './types';

/** @knip-ignore */
export const {
	Context: StartAPetitionPageDataContext,
	Provider: StartAPetitionPageDataContextProvider,
	useContext: useStartAPetitionPageData,
	useAsyncData: useStartAPetitionPageDataFromApi,
	prefetchAsyncData: prefetchStartAPetitionPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'StartAPetitionPageDataContext',
	dataProperty: 'pageData',
	getData: getStartAPetitionPageData,
	getUniqueId: () => 'start-a-petition',
	hookDeps: (_queryClient) => [], // ignoring the query client to avoid a warning - queryClient should not change anyway
	errorHandler: pageDataErrorHandler<StartAPetitionPageDataErrorCode>(),
});
